/** @jsxImportSource @emotion/react */
import React, { useState } from "react";

import styled from "@emotion/styled";

import Dialog from "@material-ui/core/Dialog";
import axios from "axios";
import PreviewIcon from "@material-ui/icons/Image";
import ToolbarButton from "./../../ToolbarButton";

import t from "translations";
import { useStoreon } from "storeon/react";

const StyledDialog = styled(Dialog)`
  > div > div {
    margin: 10px;
  }
`;

const PreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 90vw;
  max-height: 90vh;
  > img {
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
  }
`;

const Preview = (props) => {
  return (
    <StyledDialog
      open={props.isVisible}
      maxWidth={false}
      onClick={props.onClick}
    >
      <PreviewWrapper>
        <img src={props.img} alt="Preview" />
      </PreviewWrapper>
    </StyledDialog>
  );
};

const PreviewDebugger = (props) => {
  const [preview, setPreview] = useState("");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);

  const { dispatch, cachePool, canvas } = useStoreon("cachePool", "canvas");

  const imagesCachingOnServer = cachePool.length ? true : false;
  const isLoading = imagesCachingOnServer;

  return (
    <React.Fragment>
      <Preview
        img={preview}
        isVisible={!!preview.length}
        onClick={(e) => {
          setPreview("");
        }}
      />

      <ToolbarButton
        dark
        loading={isLoading || isPreviewLoading}
        onClick={() => {
          if (isLoading || isPreviewLoading) return;
          const canvasData = canvas.DPE.persistent.toBase64();
          setIsPreviewLoading(true);
          axios
            .post("/wp-json/dpe/v1/render/preview/debug", { canvasData })
            .then((resp) => {
              if (resp.data.image) {
                setPreview(resp.data.image);
                dispatch(
                  "notification/info",
                  `${t.renderedIn} ${resp.data.time.toFixed(3)}s`
                );
              }
            })
            .catch((err) => {
              console.error("Preview failed", err);
            })
            .finally((_) => {
              setIsPreviewLoading(false);
            });
        }}
        vertical
        desc={t.preview}
        icon={<PreviewIcon />}
      />
    </React.Fragment>
  );
};

export default PreviewDebugger;
